import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { LanguageProvider } from './shell/language-context';
import { SettingsProvider } from './shell/settings-context';
import { SessionProvider } from './shell/session-context';
import { AuthGate } from './shell/auth-gate';
import { ThemeProvider } from './shell/theme-context';
import { ToastProvider } from './shell/toast';
import { SignOutOverlay } from './shell/sign-out-progress';
import './theme/theme.css';
import './theme/motion.css';
import { reloadOnStaleChunk } from './shell/reload-on-stale-chunk';

// SPA entry. ThemeProvider holds the light/dark/system choice (FR-X9; the index.html
// pre-paint script already applied it), LanguageProvider the en/bn choice (DR-16),
// SettingsProvider the currency/money formatter, SessionProvider the authenticated
// customer, ToastProvider the toast stack (CB-17).
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

// A tab left open across a deploy reloads instead of failing on a removed chunk.
reloadOnStaleChunk();

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <SettingsProvider>
          <SessionProvider>
            <ToastProvider>
              <AuthGate>
                <RouterProvider router={router} />
              </AuthGate>
              <SignOutOverlay />
            </ToastProvider>
          </SessionProvider>
        </SettingsProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>,
);
